// extracted by mini-css-extract-plugin
export default {"list":"MultiForm_list__8tAF4"};